import React, { useState, useEffect } from 'react'
import { Container, Form, Button, Row, Col, Table } from 'react-bootstrap';
import {  useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { toast } from 'react-toastify';
import { useTeacherAllStudentsQuery } from '../../slices/teachers/teachersApiSlice';
import Loader from '../../components/Loader';
import Message from '../../components/Message';
import TeacherHeader from '../../components/TeacherHeader';
import TeacherNavbar from '../../components/TeacherNavbar';

const TeacherAllStudents = () => {

    const navigate = useNavigate();
    const [ subscriptions, setSubscriptions ] = useState([]);
    const [ flatsubscriptions, setFlasubscriptions ] = useState([]);
    const [ myactivesubscriptions, setMyactivesubscriptions ] = useState([]);

    const { teacherInfo } = useSelector((state) => state.authTeacher);
    const { data, error, isLoading } = useTeacherAllStudentsQuery();
    const [ totalenroll, setTotalenroll ] = useState();
    const [ totalqasked, setTotalqasked ] = useState();
    const [ totalqleft, setTotalqleft ] = useState();
    const [ totalq, setTotalq ] = useState();

    useEffect(() => {
      if(!teacherInfo) {
          navigate('/teacherlogin')
      }
    }, [navigate, teacherInfo]);

    useEffect(() => {
        if (data?.students) {
          data?.students.map((pla) => {
            subscriptions.push(pla.numberOfQuestion);
          })
          const flattenSubscriptions = (arr) => {
            return arr.reduce((acc, val) => 
              Array.isArray(val) ? acc.concat(flattenSubscriptions(val)) : acc.concat(val), 
            []);
          };
           setFlasubscriptions(flattenSubscriptions(subscriptions))
        }
    }, [data]);

    useEffect(() => {
      if (flatsubscriptions && data) {
        const filteredSubscriptions = flatsubscriptions.filter(sub => data.subjectsID.includes(sub.subject));
        const activeSubscriptions = filteredSubscriptions.filter(sub => sub.active === true);        
        const updatedSubscriptions = activeSubscriptions.map(subscription => {
          for (let j = 0; j < data?.subjectTittles.length; j++) {
            if (subscription.subject === data?.subjectTittles[j][0]) {
              return {
                ...subscription, 
                subjectname: data?.subjectTittles[j][1] 
              };
            }
          }
          return subscription;
        });             
        setMyactivesubscriptions(updatedSubscriptions);
        setTotalenroll(updatedSubscriptions.length);

      }
    }, [flatsubscriptions, data]);
   
    useEffect(() => {
        if (myactivesubscriptions) {
            const totalAsked = myactivesubscriptions.reduce((acc, sub) => acc + sub.questionsAsked, 0);
            const totalLeft = myactivesubscriptions.reduce((acc, sub) => acc + sub.questionsLeft, 0);
            const totalQuestions = myactivesubscriptions.reduce((acc, sub) => acc + sub.totalQuestions, 0);
            setTotalqasked(totalAsked);
            setTotalqleft(totalLeft);
            setTotalq(totalQuestions)
        }
    }, [myactivesubscriptions]);

    const formatDate = (dateString) => {
      const date = new Date(dateString * 1000);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    return (
        <div>
        <TeacherNavbar />
            <div className="main-content" id="panel">
            <TeacherHeader /><br /><br /><br /><br /><br />
                <div className="container-fluid mt--6">
                  <div className="row">
                    <div className="col-xl-12 ">
                      {isLoading ? ( 
                          <Loader />
                      ) : error ? (
                          <Message variant='danger'>
                              {error?.data?.message || error.error}
                          </Message>
                      ) : (
                        <>
                        <div className="card">
                          <div className="card-header border-0">
                            <h4 className="mb-0 tittleColor4 ">
                              <span className='tittleColor4'>Total Active Students</span>
                            </h4>
                          </div>
                          <div className="table-responsive">
                            <table className="table align-items-center table-flush text-center">
                              <thead className="thead-light">
                                <tr>
                                  <th scope="col" >total students enroll</th>
                                  <th scope="col" >total questions</th>
                                  <th scope="col" >total Questions Asked</th>
                                  <th scope="col" >total question left</th>
                                </tr>
                              </thead>
                              <tbody className="list text-center">
                              {
                                  myactivesubscriptions &&
                                    <tr>
                                      <td className="budget ">
                                        {totalenroll}
                                      </td>
                                      <td className="budget">
                                        {totalq}
                                      </td>
                                      <td className="budget">
                                        {totalqasked}
                                      </td>
                                      <td className="budget">
                                        {totalqleft}
                                      </td>                                                                                                                                
                                    </tr>
                              }
                                {myactivesubscriptions?.length === 0 && (
                                  <tr>
                                    <td colSpan="5">
                                      No Active Students
                                    </td>
                                  </tr>                                
                                )}
                              </tbody>
                            </table>
                          </div>                         
                        </div>

                        <div className="card">
                          <div className="card-header border-0">
                            <h4 className="mb-0 tittleColor4 ">
                              <span className='tittleColor4'> Active Students</span>
                            </h4>
                          </div>
                          <div className="table-responsive">
                            <table className="table align-items-center table-flush text-center">
                              <thead className="thead-light">
                                <tr>
                                  <th scope="col" >Name</th>
                                  <th scope="col" >Subject</th>
                                  <th scope="col" >Plan (total questions)</th>
                                  <th scope="col" >Questions Asked</th>
                                  <th scope="col" >Questions Left</th>
                                  <th scope="col" >Start Date</th>
                                  <th scope="col" >End Date</th>
                                  <th scope="col" >auto-renewal</th>
                                </tr>
                              </thead>
                              <tbody className="list text-center">
                                {
                                  myactivesubscriptions && myactivesubscriptions?.map((student) => (
                                    <tr key={student._id} >
                                      <td className="budget ">
                                            {student.name}
                                      </td>
                                      <td className="budget ">
                                            {student.subjectname}
                                      </td>
                                      <td className="budget">
                                        {student.totalQuestions}
                                      </td>
                                      <td className="budget">
                                        {student.questionsAsked}
                                      </td>
                                      <td className="budget">
                                        {student.questionsLeft}
                                      </td>
                                      <td className="budget">
                                        {formatDate(student.startDate)}

                                      </td>
                                      <td className="budget">
                                        {formatDate(student.endDate)}
                                      </td>
                                      <td className="budget">
                                        {student.renewal.toString()}
                                      </td>                                                                                           
                                    </tr>
                                  ))
                                }
                                {myactivesubscriptions?.length === 0 && (
                                  <tr>
                                    <td colSpan="8">
                                      No Active Students
                                    </td>
                                  </tr>                                
                                )}
                              </tbody>
                            </table>
                          </div>                          
                        </div>  
                        </>
                      )} 
                    </div>
                  </div>
                </div>
            </div>
        </div>
    )
}

export default TeacherAllStudents
